import { getCustomerId } from '../Common'

/**
 * HubSpot `company`：与业务约定一致，使用租户 customer id 字符串。
 * 优先 Redux `subscriptionReducer.currentInfo.customerID`，其次 JWT 中的 customerid。
 */
export function getHubSpotCompanySync(currentInfo) {
    const fromSub = (currentInfo?.customerID ?? currentInfo?.customerid ?? '').toString().trim()
    if (fromSub) return fromSub
    const fromJwt = getCustomerId()
    if (fromJwt != null && String(fromJwt).trim() !== '') return String(fromJwt).trim()
    return ''
}

/**
 * 若本地尚无 customer id，再请求现有接口 `/los/getcurrentsubscription` 取 `customerID`。
 */
export async function resolveHubSpotCompanyAsync(currentInfo) {
    const sync = getHubSpotCompanySync(currentInfo)
    if (sync) return sync
    const token = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('ZeitroA') : null
    if (!token) return ''
    try {
        const res = await fetch('/los/getcurrentsubscription', {
            method: 'GET',
            headers: { Authorization: 'Bearer ' + token, Cache: 'no-cache' },
        })
        if (!res.ok) return ''
        const data = await res.json()
        return (data?.customerID ?? data?.customerid ?? '').toString().trim() || ''
    } catch {
        return ''
    }
}
